module.exports = __webpack_public_path__ + "fonts/social.5f74697.ttf";